import { render, staticRenderFns } from "./PunishmentApproval.vue?vue&type=template&id=6d0d0db8"
import script from "./PunishmentApproval.vue?vue&type=script&lang=js"
export * from "./PunishmentApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports